import {ComponentType, lazy, LazyExoticComponent} from 'react';

export const lazyComponents: LazyExoticComponent<ComponentType<object>>[] = [];

export const ssrLazy: typeof lazy = (load) => {
    const lazyLoadedComponent = lazy(load);
    if (process.env.SSR) {
        lazyComponents.push(lazyLoadedComponent);
    }
    return lazyLoadedComponent;
};
